/* src/app/core/guards/auth/session/session-modal.component.css */
.modal-title {
  font-size: 1.5rem;
  color: #333;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
  padding: 15px;
  background-color: var(--cf-brand-dark);
  color: white;
  border-radius: 8px;
}
.modal-content {
  max-width: 800px;
  margin: auto;
  padding: 20px;
}
.sessions-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
.sessions-table th,
.sessions-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.sessions-table th {
  background-color: #f1f1f1;
  font-weight: bold;
  color: #333;
}
.sessions-table td {
  background-color: #fff;
  font-size: 0.9rem;
  color: #555;
}
.sessions-table button {
  background-color: #e57373;
  color: #fff;
  padding: 6px 12px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}
.sessions-table button:hover {
  background-color: #f44336;
}
.modal-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.cancel-button {
  background-color: #607d8b;
  color: white;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 4px;
}
.cancel-button:hover {
  background-color: #455a64;
}
/*# sourceMappingURL=session-modal.component.css.map */
